export const container: React.CSSProperties = {
  display: 'flex',
  gap: 16,
  fontWeight: 'bold',
  fontSize: 12,
  flexWrap: 'wrap',
  overflowX: 'auto',
};

export const item: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 4,
  whiteSpace: 'nowrap',
};

export const noFeaturesText: React.CSSProperties = {
  fontSize: '14px',
};
